import CEConfigurationsTabs from 'components/ConfigurationsTabs'
import React from 'react'
import { Card, CardBody, Container } from 'reactstrap'

const ViewConfiguration = (props) => {
  const{rowData,orgId, CEDid,setLoading,
  loading,}=props
  return (
    <div>
      <>
        <>
            <>
            <CEConfigurationsTabs rowData={rowData} orgId={orgId} CEDid={CEDid} setLoading={setLoading}
                loading={loading}/>
            </>
        </>
      </>
    </div>
  )
}

export default ViewConfiguration
